<template>
    <div class="services-area bg-left-color bg-left-shape bg-f4f6fc ptb-100">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="services-image" data-aos="fade-right">
                    <div class="image">
                        <!-- <img src="../../assets/img/services-image/service2.png" alt="image"> -->
                    </div>
                </div>

                <div class="services-content it-service-content" data-aos="fade-left">
                    <div class="content">
                        <!-- <div class="icon">
                            <img src="../../assets/img/bd_logo.jpeg" alt="image" style="height: 6vh">
                        </div> -->
                        <h2>Webentwicklung</h2>
                        <p>Von der einfachen Visitenkarte im Netz bis zur komplexen Webanwendung. Wir entwickeln moderne, schnelle und benutzerfreundliche Webseiten, die auf allen Geräten funktionieren.</p>

                        <div class="feature-cards-grid">
                            <div class="feature-card-mini">
                                <i class='bx bx-laptop'></i>
                                <span>Landingpages</span>
                            </div>
                            <div class="feature-card-mini">
                                <i class='bx bx-building-house'></i>
                                <span>Unternehmenswebseiten</span>
                            </div>
                            <div class="feature-card-mini">
                                <i class='bx bx-cart'></i>
                                <span>Online-Shops</span>
                            </div>
                            <div class="feature-card-mini">
                                <i class='bx bx-code-alt'></i>
                                <span>APIs & Integrationen</span>
                            </div>
                            <div class="feature-card-mini">
                                <i class='bx bx-window'></i>
                                <span>Webanwendungen</span>
                            </div>
                            <div class="feature-card-mini">
                                <i class='bx bx-devices'></i>
                                <span>Responsive Design</span>
                            </div>
                        </div>

                        <router-link to="/services/webentwicklung" class="btn-benovium">
                            <i class="bx bxs-spreadsheet"></i>
                            Mehr erfahren
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HostingServices'
}
</script>